if (!customElements.get('tula-currency-form')) {
  customElements.define(
    'tula-currency-form',
    class TulaCurrencyForm extends HTMLElement {
      constructor() {
        super();
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
      }

      connectedCallback() {
        if (this._initialized) return;

        this.input = this.querySelector('input[name="country_code"]');
        this.form = this.querySelector('form');
        this.details = this.querySelector('.tula-currency-selector__details');

        if (!this.form || !this.input) return;

        this._initialized = true;

        this.querySelectorAll('[data-currency-country]').forEach((button) => {
          button.addEventListener('click', this.onOptionClick);
        });

        document.addEventListener('click', this.onDocumentClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        this.querySelectorAll('[data-currency-country]').forEach((button) => {
          button.removeEventListener('click', this.onOptionClick);
        });
        this._initialized = false;
      }

      onOptionClick(event) {
        const button = event.currentTarget;
        const countryCode = button.dataset.currencyCountry;

        if (!countryCode || button.getAttribute('aria-current') === 'true' || !this.form || !this.input) {
          return;
        }

        event.preventDefault();
        this.closeMenu();
        this.input.value = countryCode;

        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          this.form.submit();
        }
      }

      onDocumentClick(event) {
        if (!this.details || !this.details.open || this.contains(event.target)) {
          return;
        }

        this.closeMenu();
      }

      closeMenu() {
        if (this.details) {
          this.details.open = false;
        }
      }
    }
  );
}
